import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

// icons
import StorefrontIcon from "@material-ui/icons/Storefront";
import AssessmentIcon from "@material-ui/icons/Assessment";
import PeopleIcon from "@material-ui/icons/People";
import ReceiptIcon from "@material-ui/icons/Receipt";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import Store from "@material-ui/icons/Store";
import LocalOffer from "@material-ui/icons/LocalOffer";
import TrendingUp from "@material-ui/icons/TrendingUp";
import AssignmentReturn from "@material-ui/icons/AssignmentReturn";

// dashboard card colors — same as /admin dashboard boxes
const SUCCESS_GRAD = "linear-gradient(60deg, #66bb6a, #43a047)";
const WARNING_GRAD = "linear-gradient(60deg, #ffa726, #fb8c00)";
const DANGER_GRAD = "linear-gradient(60deg, #ef5350, #e53935)";
const INFO_GRAD = "linear-gradient(60deg, #26c6da, #00acc1)";

const ICON_COLORS = [
  {
    bg: SUCCESS_GRAD,
    shadow: "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(76,175,80,.4)",
  },
  {
    bg: WARNING_GRAD,
    shadow: "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(255,152,0,.4)",
  },
  {
    bg: DANGER_GRAD,
    shadow: "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(244,67,54,.4)",
  },
  {
    bg: INFO_GRAD,
    shadow: "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(0,172,193,.4)",
  },
];

const STAT_CARDS = [
  {
    grad: SUCCESS_GRAD,
    shadow: ICON_COLORS[0].shadow,
    icon: <Store style={{ fontSize: 28, color: "#fff" }} />,
    label: "Doanh thu",
    value: "Tổng doanh thu",
  },
  {
    grad: WARNING_GRAD,
    shadow: ICON_COLORS[1].shadow,
    icon: <LocalOffer style={{ fontSize: 28, color: "#fff" }} />,
    label: "Đơn hàng",
    value: "Quản lý đặt hàng",
  },
  {
    grad: DANGER_GRAD,
    shadow: ICON_COLORS[2].shadow,
    icon: <TrendingUp style={{ fontSize: 28, color: "#fff" }} />,
    label: "Lợi nhuận",
    value: "Doanh thu thuần",
  },
  {
    grad: INFO_GRAD,
    shadow: ICON_COLORS[3].shadow,
    icon: <AssignmentReturn style={{ fontSize: 28, color: "#fff" }} />,
    label: "Trả hàng",
    value: "Quản lý hoàn trả",
  },
];

const FEATURES = [
  {
    icon: <StorefrontIcon />,
    name: "Quản lý hàng hóa & kho",
    desc: "Theo dõi tồn kho real-time, cảnh báo hàng sắp hết, quản lý nhiều kho cùng lúc.",
    color: ICON_COLORS[0],
  },
  {
    icon: <ReceiptIcon />,
    name: "Quản lý đơn hàng",
    desc: "Tạo & xử lý đơn hàng bán buôn, bán lẻ nhanh chóng. Hỗ trợ đặt hàng và giao hàng.",
    color: ICON_COLORS[1],
  },
  {
    icon: <PeopleIcon />,
    name: "Quản lý khách hàng",
    desc: "Lưu trữ thông tin khách hàng, lịch sử mua hàng, công nợ và chính sách giá riêng.",
    color: ICON_COLORS[2],
  },
  {
    icon: <AssessmentIcon />,
    name: "Báo cáo doanh thu",
    desc: "Báo cáo doanh số, lợi nhuận, hàng tồn kho theo ngày, tuần, tháng trực quan.",
    color: ICON_COLORS[3],
  },
  {
    icon: <LocalShippingIcon />,
    name: "Quản lý nhà cung cấp",
    desc: "Quản lý nhập hàng, theo dõi công nợ với nhà cung cấp, lịch sử giao dịch.",
    color: ICON_COLORS[0],
  },
  {
    icon: <AccountBalanceWalletIcon />,
    name: "Thanh toán linh hoạt",
    desc: "Hỗ trợ tiền mặt, chuyển khoản, trả góp. Ghi nhận công nợ và nhắc nợ tự động.",
    color: ICON_COLORS[1],
  },
];

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  logo: {
    fontWeight: 800,
    fontSize: 24,
    color: "#43a047",
    letterSpacing: -0.5,
    cursor: "pointer",
    flexGrow: 1,
  },
  navBtn: {
    fontWeight: 600,
    borderRadius: 8,
    textTransform: "none",
    fontSize: 15,
  },
  page: {
    background: "#eeeeee",
    minHeight: "100vh",
    paddingTop: 64,
  },
  hero: {
    padding: "60px 0 48px",
  },
  heroTag: {
    display: "inline-block",
    background: "linear-gradient(60deg, #26c6da, #00acc1)",
    color: "#fff",
    borderRadius: 20,
    padding: "4px 14px",
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 16,
    boxShadow:
      "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(0,172,193,.4)",
  },
  heroTitle: {
    fontWeight: 800,
    fontSize: 38,
    lineHeight: 1.25,
    color: "#3C4858",
    marginBottom: 16,
    [theme.breakpoints.down("sm")]: { fontSize: 26 },
  },
  heroSub: {
    fontSize: 16,
    color: "#777",
    lineHeight: 1.7,
    marginBottom: 32,
    maxWidth: 500,
  },
  heroCta: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    fontSize: 15,
    padding: "11px 28px",
    background: SUCCESS_GRAD,
    color: "#fff",
    marginRight: 12,
    boxShadow:
      "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(76,175,80,.4)",
    "&:hover": { background: "#43a047" },
  },
  heroCtaOutline: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    fontSize: 15,
    padding: "11px 28px",
    borderColor: "#00acc1",
    color: "#00acc1",
    "&:hover": { background: "rgba(0,172,193,0.08)" },
  },
  // Dashboard-style stat card
  statCard: {
    borderRadius: 6,
    boxShadow: "0 1px 4px 0 rgba(0,0,0,.14)",
    marginBottom: 16,
    position: "relative",
    overflow: "visible",
  },
  statIconBox: {
    borderRadius: 6,
    padding: "14px 16px",
    marginTop: -20,
    marginRight: 16,
    float: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
  },
  statBody: {
    padding: "12px 20px 8px",
    textAlign: "right",
  },
  statLabel: {
    color: "#999",
    fontSize: 13,
    margin: 0,
    fontWeight: 400,
  },
  statValue: {
    color: "#3C4858",
    fontSize: 16,
    fontWeight: 700,
    margin: "4px 0 0",
  },
  // Features section
  section: {
    padding: "0 0 56px",
  },
  sectionTag: {
    display: "inline-block",
    background: WARNING_GRAD,
    color: "#fff",
    borderRadius: 20,
    padding: "4px 14px",
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 12,
    boxShadow:
      "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(255,152,0,.4)",
  },
  sectionTitle: {
    fontWeight: 800,
    fontSize: 28,
    color: "#3C4858",
    marginBottom: 8,
    [theme.breakpoints.down("sm")]: { fontSize: 22 },
  },
  sectionSub: {
    fontSize: 15,
    color: "#777",
    marginBottom: 32,
    maxWidth: 560,
  },
  featureCard: {
    borderRadius: 6,
    boxShadow: "0 1px 4px 0 rgba(0,0,0,.14)",
    height: "100%",
    transition: "box-shadow 0.2s",
    "&:hover": { boxShadow: "0 8px 24px rgba(0,0,0,.12)" },
  },
  featureIconBox: {
    width: 48,
    height: 48,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 14,
    "& svg": { fontSize: 26, color: "#fff" },
  },
  featureName: {
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 6,
    color: "#3C4858",
  },
  featureDesc: {
    fontSize: 14,
    color: "#777",
    lineHeight: 1.6,
  },
  footer: {
    background: "#3C4858",
    color: "#aaa",
    padding: "24px 0",
    textAlign: "center",
    fontSize: 13,
  },
}));

export default function HomePage() {
  const classes = useStyles();
  const history = useHistory();
  const isAuthenticated = !!localStorage.getItem("token");
  const handleCta = () =>
    history.push(isAuthenticated ? "/admin/dashboard" : "/auth/login-page");

  return (
    <div>
      {/* Navbar */}
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography
            className={classes.logo}
            onClick={() => history.push("/")}
          >
            Liti
          </Typography>
          {!isAuthenticated && (
            <Button
              className={classes.navBtn}
              style={{ color: "#555", marginRight: 8 }}
              onClick={() => history.push("/auth/login-page")}
            >
              Đăng nhập
            </Button>
          )}
          <Button
            variant={isAuthenticated ? "text" : "contained"}
            className={classes.navBtn}
            style={
              isAuthenticated
                ? { color: "#555" }
                : {
                    background: "linear-gradient(60deg, #66bb6a, #43a047)",
                    color: "#fff",
                    boxShadow:
                      "0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(76,175,80,.4)",
                  }
            }
            onClick={handleCta}
          >
            {isAuthenticated ? "Vào dashboard" : "Dùng thử miễn phí"}
          </Button>
        </Toolbar>
      </AppBar>

      <div className={classes.page}>
        {/* Hero */}
        <div className={classes.hero}>
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="flex-start">
              <Grid item xs={12} md={6}>
                <div className={classes.heroTag}>
                  Giải pháp bán buôn &amp; bán lẻ
                </div>
                <Typography className={classes.heroTitle}>
                  Phần mềm quản lý cửa hàng toàn diện — đơn giản &amp; hiệu quả
                </Typography>
                <Typography className={classes.heroSub}>
                  Liti giúp bạn quản lý hàng hóa, đơn hàng, khách hàng và doanh
                  thu chỉ trên một nền tảng. Tiết kiệm thời gian, tăng lợi
                  nhuận.
                </Typography>
                <Button className={classes.heroCta} onClick={handleCta}>
                  Dùng thử miễn phí
                </Button>
                {!isAuthenticated && (
                  <Button
                    variant="outlined"
                    className={classes.heroCtaOutline}
                    onClick={() => history.push("/auth/login-page")}
                  >
                    Đăng nhập
                  </Button>
                )}
              </Grid>

              {/* 4 dashboard-style stat cards */}
              <Grid item xs={12} md={6}>
                <Grid container spacing={2} style={{ marginTop: 8 }}>
                  {STAT_CARDS.map((s) => (
                    <Grid item xs={6} key={s.label}>
                      <Card className={classes.statCard}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div
                            className={classes.statIconBox}
                            style={{ background: s.grad, boxShadow: s.shadow }}
                          >
                            {s.icon}
                          </div>
                        </div>
                        <div className={classes.statBody}>
                          <p className={classes.statLabel}>{s.label}</p>
                          <p className={classes.statValue}>{s.value}</p>
                        </div>
                        <div style={{ height: 8 }} />
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>

        {/* Features */}
        <div className={classes.section}>
          <Container maxWidth="lg">
            <div className={classes.sectionTag}>Tính năng nổi bật</div>
            <Typography className={classes.sectionTitle}>
              Mọi thứ bạn cần để vận hành cửa hàng
            </Typography>
            <Typography className={classes.sectionSub}>
              Từ nhập hàng đến bán hàng, từ quản lý khách hàng đến báo cáo doanh
              thu — Liti lo tất cả.
            </Typography>
            <Grid container spacing={3}>
              {FEATURES.map((f) => (
                <Grid item xs={12} sm={6} md={4} key={f.name}>
                  <Card className={classes.featureCard}>
                    <CardContent style={{ padding: 24 }}>
                      <div
                        className={classes.featureIconBox}
                        style={{
                          background: f.color.bg,
                          boxShadow: f.color.shadow,
                        }}
                      >
                        {f.icon}
                      </div>
                      <Typography className={classes.featureName}>
                        {f.name}
                      </Typography>
                      <Typography className={classes.featureDesc}>
                        {f.desc}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </div>

        {/* Footer */}
        <div className={classes.footer}>
          <Container>
            <Typography style={{ color: "#aaa", fontSize: 13 }}>
              © {new Date().getFullYear()} Liti — Phần mềm quản lý cửa hàng bán
              buôn, bán lẻ.
            </Typography>
          </Container>
        </div>
      </div>
    </div>
  );
}
